import { useContext, useState } from "react";
import "./Footer.css";
import dslLogo from "../../Assets/Images/icon.png";
import social1 from "../../Assets/Images/twitter2.png";
import social3 from "../../Assets/Images/linked-in-icon.png";
import instaIcon from "../../Assets/Images/insta-icon.png";
import tiktokIcon from "../../Assets/Images/tiktok-icon.png";
import social4 from "../../Assets/Images/pinterest-icon.png";
import social5 from "../../Assets/Images/medium-icon.png";
import truthSocialIcon from "../../Assets/Images/truth-social.png";
import lemon8Icon from "../../Assets/Images/lemon8.png";
import { FaFacebookF, FaYoutube } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import InfoIcon from '@mui/icons-material/Info';
import { Button, Modal } from 'antd';

const Footer = () => {
  const { AIuser } = useContext(UserAuthContext);
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const goToRoute = (path) => {
    if (AIuser) {
      navigate(path);
    } else {
      navigate("/sign-in", { state: { from: path } });
    }
  };

  const ai = [
    { path: "/business-plan-ai", label: "Business Plan AI" },
    { path: "/comic-video-ai", label: "Comic Video AI" },
    { path: "/fact-of-the-day-ai", label: "Fact Of The Day AI" },
    { path: "/image-ai", label: "Image AI" },
    { path: "/news-poster-ai", label: "News Poster AI" },
    { path: "/promo-campaign-ai", label: "Promo Campaign AI" },
    { path: "/poster-design-ai", label: "Poster Design AI" },
    { path: "/product-video-ai", label: "Product Video AI" },
    { path: "/social-post-ai", label: "Social Post AI" },
    { path: "/text-ai", label: "Text AI" },
    { path: "/toy-stories-ai", label: "Toy Stories AI" },
    { path: "/voice-ai", label: "Voice AI" },
    { path: "/video-ai", label: "Video AI" },
  ];

  const quickLinks = [
    { path: "/about-us", label: "About Us" },
    { path: "/contact", label: "Contact Us" },
    { path: "/termsofuse", label: "Terms Of Use" },
    // { path: "/dataprotectionnotice", label: "Privacy Policy" },
    { path: "/dataprotectionnotice", label: "Data Protection Notice" },
    { path: "/support", label: "Support" },
    // { path: "/contents", label: "Blog" },
  ];

  return (
    <>
      <div className="footer-container">
        <div className="container px-4">
          <div className="row gy-5 g-md-0 g-lg-0 justify-content-between footer-main">
            {/* Left Column - Brand */}
            <div className="col-md-4 col-lg-4 col-12 footer-brand-col">
              <div className="footer-brand-header">
                <img className="footer-logo" src={dslLogo} alt="WhalesAI Logo" />
                <h3 className="footer-brand-name">WHALESAI.COM</h3>
              </div>

              <p className="footer-tagline">
                Our Multi-Model AI Orchestration + Proprietary Content Generation Workflow combines multiple leading AI models to intelligently create, process, and deliver unique, high-quality content tailored to each user's request. <InfoIcon onClick={() => setIsModalVisible(true)} style={{ cursor: "pointer" }} />
              </p>

              <p
                className="footer-consultant-link"
                style={{ cursor: "pointer" }}
                onClick={() => goToRoute("/social-media-consultant")}
              >
                <span className="consultant-ai-text" style={{ fontSize: "18px" }}>Social Media Consultant</span>
              </p>

              {/* Developer (DSL Singapore) */}
              <p className="footer-social-label mt-4 mb-2" style={{ opacity: 0.85 }}>Developer</p>
              <div className="footer-social-icons">
                <Link to="https://www.linkedin.com/company/dslsingapore" target="_blank" className="footer-social-icon-link">
                  <img src={social3} alt="LinkedIn" />
                </Link>
                <Link to="https://www.facebook.com/dslegendssingapore" target="_blank" className="footer-social-icon-link">
                  <FaFacebookF className="footer-react-icon" />
                </Link>
                <Link to="https://www.instagram.com/dslegendssingapore" target="_blank" className="footer-social-icon-link">
                  <img src={instaIcon} alt="Instagram" />
                </Link>
                <Link to="https://twitter.com/dslsingapore" target="_blank" className="footer-social-icon-link">
                  <img src={social1} alt="Twitter" />
                </Link>
                <Link to="https://truthsocial.com/@dslsingapore" target="_blank" className="footer-social-icon-link">
                  <img src={truthSocialIcon} alt="Truth Social" />
                </Link>
                <Link to="https://www.pinterest.com/dslsingapore" target="_blank" className="footer-social-icon-link">
                  <img src={social4} alt="Pinterest" />
                </Link>
                <Link to="https://medium.com/@dslsingapore" target="_blank" className="footer-social-icon-link">
                  <img src={social5} alt="Medium" />
                </Link>
              </div>

              {/* WhalesAI */}
              <p className="footer-social-label mt-3 mb-2" style={{ opacity: 0.85 }}>WhalesAI</p>
              <div className="footer-social-icons">
                <Link to="https://www.instagram.com/whalesaicom" target="_blank" className="footer-social-icon-link">
                  <img src={instaIcon} alt="Instagram" />
                </Link>
                <Link to="https://x.com/whalesaicom" target="_blank" className="footer-social-icon-link">
                  <img src={social1} alt="X" />
                </Link>
                <Link to="https://www.tiktok.com/@livetoeatonly" target="_blank" className="footer-social-icon-link">
                  <img src={tiktokIcon} alt="TikTok" />
                </Link>
                <Link to="https://s.lemon8-app.com/s/GgkefRUbwj" target="_blank" className="footer-social-icon-link">
                  <img src={lemon8Icon} alt="Lemon8" />
                </Link>
              </div>
            </div>

            {/* Middle Column - AI*/}
            <div className="col-md-3 col-lg-3 col-12 footer-links-col">
              <h3 className="footer-heading">AI</h3>
              <div className="footer-links-list">
                {ai.map(({ path, label }) => (
                  <p
                    key={label}
                    className="footer-link-item"
                    onClick={() => goToRoute(path)}
                  >
                    {label}
                  </p>
                ))}
              </div>
            </div>

            {/* Right Column - Quick Links */}
            <div className="col-md-3 col-lg-3 col-12 footer-links-col">
              <h3 className="footer-heading">Quick Links</h3>
              <div className="footer-links-list">
                {quickLinks.map(({ path, label }) => (
                  <Link key={label} to={path} className="footer-resource-link">
                    <p className="footer-link-item">{label}</p>
                  </Link>
                ))}
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div>
            <p className="copy-right-text">
              © Whalesai.com | All rights reserved {new Date().getFullYear()}.
            </p>
          </div>
        </div>
      </div>
      <Modal
        title="Multi-Model AI Orchestration + Proprietary Content Generation Workflow"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={
          <div style={{ textAlign: "center" }}>
            <Button
              type="primary"
              onClick={() => setIsModalVisible(false)}
            >
              Close
            </Button>
          </div>
        }
        width={800}
      >
        <div style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: '10px' }}>
          <h5 style={{ fontWeight: 'bold' }}>Multi-Model AI Orchestration</h5>
          <ul>
            <li>The platform uses several AI models, each chosen for specific strengths.</li>
            <li>One model may be better at research, another at writing, another at image analysis, and another at quality checking.</li>
            <li>An orchestration layer automatically decides which model should perform each task and combines their outputs into a single workflow.</li>
          </ul>

          <h5 style={{ fontWeight: 'bold', marginTop: '20px' }}>Proprietary Content Generation Workflow</h5>
          <ul>
            <li>Beyond the AI models themselves, the company has developed its own custom processes, rules, prompts, templates, validation systems, and automation logic.</li>
            <li>These proprietary components help ensure consistency, quality, accuracy, formatting, and brand-specific requirements.</li>
          </ul>

          <h5 style={{ fontWeight: 'bold', marginTop: '20px' }}>How It Works</h5>
          <ol>
            <li><strong>User submits a request</strong>
              <ul><li>Example: "Create a social media post about renewable energy."</li></ul>
            </li>
            <li><strong>Request analysis</strong>
              <ul><li>The system determines what tasks are needed (research, writing, fact-checking, formatting, image generation, etc.).</li></ul>
            </li>
            <li><strong>Model selection</strong>
              <ul><li>Different AI models are assigned to different parts of the task based on their capabilities.</li></ul>
            </li>
            <li><strong>Content generation</strong>
              <ul><li>The selected models generate drafts, ideas, summaries, visuals, or other content.</li></ul>
            </li>
            <li><strong>Processing and refinement</strong>
              <ul><li>Proprietary workflows review, improve, structure, and optimize the generated content.</li></ul>
            </li>
            <li><strong>Quality control</strong>
              <ul><li>Additional AI checks may verify grammar, style, consistency, factual accuracy, and compliance requirements.</li></ul>
            </li>
            <li><strong>Final delivery</strong>
              <ul><li>The user receives polished content tailored to their specific request.</li></ul>
            </li>
          </ol>

          <h5 style={{ fontWeight: 'bold', marginTop: '20px' }}>Benefits</h5>
          <ul>
            <li>Higher-quality output than relying on a single AI model.</li>
            <li>Better accuracy through cross-checking and validation.</li>
            <li>More specialized handling of different tasks.</li>
            <li>Consistent formatting and branding.</li>
            <li>Ability to generate personalized content at scale.</li>
            <li>Faster and more efficient content production.</li>
          </ul>
        </div>
      </Modal>
    </>
  );
};

export default Footer;
